// removed by extract-text-webpack-plugin
module.exports = {"Card":"_3pB9WMjJAylH3izqfqXY7","CardHeader":"_1qsKJm2DNmq90SU28u360x","CardBody":"_2sZRggpEMeB1afmqm8EFvT","Media":"_1DfSxsjyC3IhUiVn8vFhPB","MediaIcon":"_3haS1xblb585wgBc7WtX7M","MediaBody":"_1GxOFWDKHhmkJpcwt_k9Ak","MediaMore":"_1TZoQ2tJqFpWHPeHY_5VGn","Desc":"_2FNhkF5EeV0KElOgoRP8kM","Link":"tpoNV98rdhOAHkIu-Jtcb","Icon":"llL-l9AtWeDVo0DoDLmJz"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/PaymentsOnMonth/styles.module.css
// module id = 561
// module chunks = 0